import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";
import Selector from "../../../components/dropdown/commonDropdown/Selector";

export const rowData = [];
export const colDefs = [
    // {
    //     field: "idBankToBank",
    //     headerName: "ID Bank To Bank",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "srNo",
    //     headerName: "Sr No",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "transferNo",
    //     headerName: "Transfer No",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "transferDate",
    //     headerName: "Transfer Date",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "accountHead",
    //     headerName: "Account Head",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "fromAcType",
    //     headerName: "From AC Type",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "bankName",
    //     headerName: "Bank Name",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "amount",
    //     headerName: "Amount",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
    // {
    //     field: "status",
    //     headerName: "Status",
    //     flex: 1,
    //     filter: true,
    //     floatingFilter: true,
    // },
];

export const table2Data = [];
export const table2ColDefs = [];

export const BankToBankTransferTable = (props) => {
    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Employee basic details</span>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mt-[12px] mb-3">
                        <div className="input-outer-grp grid grid-cols-2 gap-2.5">
                            <div className="input-grp">
                                <label>Voucher no</label>
                                <TextInput
                                    type="number"
                                    id="voucherNo"
                                    name="transferNo"
                                    value={props.bankToBankDetails.transferNo}
                                    handleChange={(event) => props.handleChange(event, "transferNo")}
                                    disabled />
                            </div>

                            <div className="input-grp">
                                <label>Date</label>
                                <TextInput
                                    type="date"
                                    id="date"
                                    name="transferDate"
                                    value={props.bankToBankDetails.transferDate}
                                    handleChange={(event) => props.handleChange(event, "transferDate")}
                                    className={props.validState?.error?.transferDate !== undefined ? "error" : ""} />
                            </div>
                        </div>

                        <div className="input-grp">
                            <label>Acc. sub head</label>
                            <SingleSelectWithSearch
                                drpIdentity={"aCCSubHeadList"}
                                optionArray={props.bankToBankDetails.aCCSubHeadList}
                                value={props.bankToBankDetails.idGeneralProduct}
                                searchText={props.bankToBankDetails.productName}
                                handleChangeTest={props.handleSelectChange}
                                disabled={true}
                                classParams={props.validState?.error?.idGeneralProduct !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                            />
                            {/* <SingleSelectWithSearch
                                id="accSubHead"
                                name="accSubHead"
                                value={props.bankToBankDetails.aCCSubHeadList}
                                handleChangeTest={(event) => props.handleSelectChange(event, "accSubHead")}
                                className={props.validState?.error?.accSubHead !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Payment mode</label>
                            <SingleSelectWithSearch
                                drpIdentity={"PaymentMode"}
                                optionArray={props.bankToBankDetails.paymentModeList}
                                value={props.bankToBankDetails.idPaymentMode}
                                searchText={props.bankToBankDetails.paymentMode}
                                handleChangeTest={props.handleSelectChange}
                                // disabled={true}
                                classParams={props.validState?.error?.idPaymentMode !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                            />
                            {/* <SingleSelectWithSearch
                                id="paymentMode"
                                name="paymentMode"
                                value={props.bankToBankDetails.paymentMode}
                                handleChangeTest={(event) => props.handleSelectChange(event, "paymentMode")}
                                className={props.validState?.error?.paymentMode !== undefined ? "error" : ""} /> */}
                        </div>

                    </div>
                    <div className="item-inner grid grid-cols-2 gap-2.5 mb-3">
                        <div className="input-outer-grp flex gap-2.5">
                            <div className="input-grp w-[75%]">
                                <label>From account</label>
                                <SingleSelectWithSearch
                                    drpIdentity={"FromAccount"}
                                    optionArray={props.bankToBankDetails.bankList}
                                    value={props.bankToBankDetails.fromAC}
                                    searchText={props.bankToBankDetails.fromACType}
                                    handleChangeTest={props.handleSelectChange}
                                    // disabled={true}
                                    classParams={props.validState?.error?.fromAC !== undefined ? "error" : ""}
                                    setFilterParameters={props.setFilterParameters}
                                />
                                {/* <SingleSelectWithSearch
                                    id="fromAccount"
                                    name="fromAccount"
                                    value={props.bankToBankDetails.fromAccount}
                                    handleChangeTest={(event) => props.handleSelectChange(event, "fromAccount")}
                                    className={props.validState?.error?.fromAccount !== undefined ? "error" : ""} /> */}
                            </div>

                            <div className="input-grp w-[25%]">
                                <label>Type</label>
                                <SingleSelectWithSearch
                                    //id="type"
                                    //name="type"
                                    //value={props.types} 
                                    drpIdentity={"fromAccountType"}
                                    optionArray={props.bankToBankDetails.types}
                                    //handleChangeTest={(event) => props.handleSelectChange(event, "type")}
                                    value={props.bankToBankDetails.fromAccountTypeId}
                                    searchText={props.bankToBankDetails.fromAccountTypeName}
                                    classParams={props.validState?.error?.fromAccountTypeId !== undefined ? "error" : ""}
                                    //setFilterParameters={props.setFilterParameters}
                                    disabled={true}
                                />
                                {/* <SingleSelectWithSearch
                                    id="fromAccountType"
                                    name="fromAccountType"
                                    value={props.bankToBankDetails.fromAccountType}
                                    handleChangeTest={(event) => props.handleSelectChange(event, "fromAccountType")}
                                    className={props.validState?.error?.fromAccountType !== undefined ? "error" : ""} /> */}
                            </div>
                        </div>

                        <div className="input-outer-grp flex gap-2.5">
                            <div className="input-grp w-[75%]">
                                <label>Select bank</label>
                                <SingleSelectWithSearch
                                    drpIdentity={"selectBank"}
                                    optionArray={props.bankToBankDetails.toBankList}
                                    value={props.bankToBankDetails.idBank}
                                    searchText={props.bankToBankDetails.bankName}
                                    handleChangeTest={props.handleSelectChange}
                                    // disabled={true}
                                    classParams={props.validState?.error?.idBank !== undefined ? "error" : ""}
                                    setFilterParameters={props.setFilterParameters}
                                />

                                {/* <SingleSelectWithSearch
                                    id="selectBank"
                                    name="selectBank"
                                    value={props.bankToBankDetails.selectBank}
                                    handleChangeTest={(event) => props.handleSelectChange(event, "selectBank")}
                                    className={props.validState?.error?.selectBank !== undefined ? "error" : ""} /> */}
                            </div>

                            <div className="input-grp w-[25%]">
                                <label>Type</label>
                                {/* <SingleSelectWithSearch
                                    id="selectBankType"
                                    name="selectBankType"
                                    value={props.bankToBankDetails.selectBankType}
                                    handleChangeTest={(event) => props.handleSelectChange(event, "selectBankType")}
                                    className={props.validState?.error?.selectBankType !== undefined ? "error" : ""} /> */}
                                <SingleSelectWithSearch
                                    //id="type"
                                    //name="type"
                                    //value={props.types} 
                                    drpIdentity={"selectBankType"}
                                    optionArray={props.bankToBankDetails.types}
                                    //handleChangeTest={(event) => props.handleSelectChange(event, "type")}
                                    value={props.bankToBankDetails.selectBankTypeId}
                                    searchText={props.bankToBankDetails.selectBankTypeName}
                                    // classParams={props.validState?.error?.selectBankTypeId !== undefined ? "error" : ""}
                                    //setFilterParameters={props.setFilterParameters}
                                    disabled={true}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Select series</label>
                            <SingleSelectWithSearch
                                drpIdentity={"selectSeries"}
                                optionArray={props.bankToBankDetails.seriesList}
                                value={props.bankToBankDetails.idChequeBookMaster}
                                searchText={props.bankToBankDetails.chequeBookSeries}
                                handleChangeTest={props.handleSelectChange}
                                // disabled={true}
                                // classParams={props.validState?.error?.idChequeBookMaster !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                            />
                            {/* <SingleSelectWithSearch
                                id="selectSeries"
                                name="selectSeries"
                                value={props.bankToBankDetails.selectSeries}
                                handleChangeTest={(event) => props.handleSelectChange(event, "selectSeries")}
                                className={props.validState?.error?.selectSeries !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Cheque no</label>
                            <SingleSelectWithSearch
                                drpIdentity={"chequeNo"}
                                optionArray={props.bankToBankDetails.chequeNoList}
                                value={props.bankToBankDetails.idChequeBookDetails}
                                searchText={props.bankToBankDetails.chequeNo}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                            // className={props.validState?.error?.idChequeBookDetails !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch
                                id="chequeNo"
                                name="chequeNo"
                                value={props.bankToBankDetails.chequeNo}
                                handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")}
                                className={props.validState?.error?.chequeNo !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Cheque date</label>
                            <TextInput
                                type="date"
                                id="chequeDate"
                                name="chequeDate"
                                value={props.bankToBankDetails.chequeDate}
                                handleChange={(event) => props.handleChange(event, "chequeDate")}
                            // className={props.validState?.error?.chequeDate !== undefined ? "error" : ""}
                            />
                        </div>

                        <div className="input-grp">
                            <label>Reference no</label>
                            <TextInput
                                type="text"
                                id="refNo"
                                name="refNo"
                                value={props.bankToBankDetails.refNo}
                                handleChange={(event) => props.handleChange(event, "refNo")}
                            // className={props.validState?.error?.refNo !== undefined ? "error" : ""}
                            />
                        </div>
                    </div>

                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3.5">
                        <div className="input-grp">
                            <label>Amount</label>
                            <TextInput
                                type="number"
                                id="amount"
                                name="amount"
                                value={props.bankToBankDetails.amount}
                                handleChange={(event) => props.handleChange(event, "amount")}
                                className={props.validState?.error?.amount !== undefined ? "error" : ""} />
                        </div>

                        <div className="input-grp col-span-2">
                            <label>Authorised by</label>
                            <SingleSelectWithSearch
                                drpIdentity={"employeeList"}
                                optionArray={props.bankToBankDetails.employeeList}
                                value={props.bankToBankDetails.idEmployee}
                                searchText={props.bankToBankDetails.employeeName}
                                handleChangeTest={props.handleSelectChange}
                                // disabled={true}
                                //classParams={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                            />
                            {/* <SingleSelectWithSearch
                                id="authorisedBy"
                                name="authorisedBy"
                                value={props.bankToBankDetails.authorisedBy}
                                handleChangeTest={(event) => props.handleSelectChange(event, "authorisedBy")}
                                className={props.validState?.error?.authorisedBy !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Remarks</label>
                            <TextInput
                                type="text"
                                id="remarks"
                                name="remarks"
                                value={props.bankToBankDetails.remarks}
                                handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>

                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns"
                            onClick={() => props.submit()}
                            disabled={props.isSaving}
                        >
                            {props.bankToBankDetails.updateStatus === 1 ? "Update" : "Save"}</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    )
}